<script lang="ts">
    import Content from "../lib/components/Content.svelte"
    import { previewEntryMap } from "../preview"

    let previewContent: ContentEntry
    $: previewContent = $previewEntryMap["content"] as ContentEntry
</script>

{#if previewContent}
    <Content {previewContent} />
{/if}
